import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { roundWeighted } from '../../../util/CommonUtils';

const SampleWeightedHeader = styled.span`
  font-size: 8px;
  font-style: normal;
  font-weight: 500;
  line-height: 9px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #828282;
`;

// Sample value colored red when < 40
const SampleWeightedValue = styled.span`
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color: ${props => (props.red ? '#E16862' : '#181818')};
`;

// Tweaks to make cols in top row better spaced
// and right cols with a border on the left
const Column = styled.div`
  line-height: ${props => (props.top ? 1 : 'normal')};
  border-left: ${props => (props.right ? 'solid 1px #E0E0E0' : 'none')};
`;

const AutocodeSampleWeightedDisplay = props => {
  return (
    <React.Fragment>
      <div className="row">
        <Column top className="columns small-6">
          <SampleWeightedHeader>SAMPLE</SampleWeightedHeader>
        </Column>
        <Column top right className="columns small-6">
          <SampleWeightedHeader>WEIGHTED</SampleWeightedHeader>
        </Column>
      </div>
      <div className="row">
        <Column className="columns small-6">
          <SampleWeightedValue
            // color sample red when under limits
            // different limit for NCS or non-NCS studies
            red={
              props.sample < props.sampleRedLimit ||
              (props.sample < props.sampleRedLimitNCS &&
                props.study.ss === 'SIMMONS')
            }
            data-test="sample-value"
          >
            {Math.round(props.sample)}
          </SampleWeightedValue>
        </Column>
        <Column right className="columns small-6">
          <SampleWeightedValue data-test="weighted-value">
            {roundWeighted(props.weighted)}
          </SampleWeightedValue>
        </Column>
      </div>
    </React.Fragment>
  );
};

AutocodeSampleWeightedDisplay.propTypes = {
  sample: PropTypes.number,
  weighted: PropTypes.number,
  study: PropTypes.shape({
    ss: PropTypes.string,
  }),
  sampleRedLimit: PropTypes.number,
  sampleRedLimitNCS: PropTypes.number,
};

export default AutocodeSampleWeightedDisplay;
